// extracted by mini-css-extract-plugin
module.exports = {"grid-tablet-breakpoint":"575px","double-space":"16px","container":"SettingsError_container__QSa-g"};